export const URL_SERVICIOS = "http://cjnfendipetroleo.grupoata.co/_REST2/index.php/";
export const URL_CLAUSULADO = "http://fendipetroleo.cjnasesores.com.co/clausulado/";


// WEBPACK FOOTER //
// ./src/config/url.ts